export default __webpack_public_path__ + "static/media/100.afe892f9.svg";